const CLIENT_OPERATION_ROLES = new Set(['OWNER', 'ADMIN', 'OFFICE', 'REFERRAL_COORDINATOR']);

/**
 * Client add, chart-profile edit, treating-provider assignment, call, fax,
 * and recording a returned physician fax signature.
 * Referral Coordinator stays included because intake already depends on Add Client
 * (directory shortcut, sidebar, and mobile nav) and on chart editing, call, and fax.
 */
export function canManageClientOperations(role: string | null | undefined): boolean {
  return CLIENT_OPERATION_ROLES.has(String(role || '').trim().toUpperCase());
}
